import React from "react";
import CustomModal from "../../core/modal";
import { Button, Stack, Typography } from "@mui/material";

const DeleteModal = ({ deleteHandler, onClose }) => {
  return (
    <div>
      <CustomModal title="Sure you want to delete?" onClose={onClose}>
        <Typography variant="body1">
          This action cannot be undone. Please confirm before proceeding.
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}
        >
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => deleteHandler()}
          >
            Delete
          </Button>
        </Stack>
      </CustomModal>
    </div>
  );
};

export default DeleteModal;
